/* eslint-disable */
import session from './session';

export default {
  getPaymentList(filter) {
    return session.get(`/api/v1/payment/${filter}`);
  },
  getProviderPaymentList(filter) {
    return session.get(`/api/v1/provider_payment/${filter}`);
  },
  getDealerPaymentList(filter) {
    return session.get(`/api/v1/dealer_payment/${filter}`);
  },
  getSubscriptionPaymentList(filter) {
    return session.get(`/api/v1/subscription_payment/${filter}`);
  },
  getRefundPaymentList(filter) {
    return session.get(`/api/v1/refund_payment/${filter}`);
  },
  createPayment(data) {
    return session.post(`/api/v1/payment/`, data);
  },
  createDealerPayment(data) {
    return session.post(`/api/v1/dealer_payment/`, data);
  },
  updateDealerPayment(id, data) {
    return session.patch(`/api/v1/dealer_payment/${id}/`, data);
  },
  checkPayment(id) {
    return session.get(`/api/v1/payment/${id}/`);
  },
};
